import styled, { css } from 'styled-components';
import { isDiferentiatedBrands } from '../../../themes/themes';
import { getBrandStorage } from '../../../utils/getBrand';

const brand = getBrandStorage();

export const Wrapper = styled.div`
  font-family: 'Poppins', sans-serif;

  ${({ theme }) => css`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    .filter-group {
      display: flex;
      flex-direction: column;
      padding: 16px 20px;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }
    }

    .outlined-input-iconed {
      background-color: ${isDiferentiatedBrands(brand)
        ? theme.palette.secondary.white
        : '#f8f8f8'};
      border-radius: 8px;
      height: 40px;
      font-size: 13px;
    }

    .MuiSlider-root {
      margin-top: 8px;
    }

    .MuiRating-root {
      margin-top: 4px;
    }
  `}
`;

export const FilterHeader = styled.div`
  background: #f5f5f5;
  padding: 14px 20px;
`;

export const FilterHeaderTitle = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #555;
  letter-spacing: 0.3px;
`;

export const FilterTitle = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #888;

    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 14px;
      background: ${theme.palette.primary.main};
      border-radius: 2px;
      flex-shrink: 0;
    }
  `}
`;

export const ThinText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 4px;
`;
